module.exports = __webpack_public_path__ + "img/close-0.cb23e4e9.svg";